import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import IndustriesSection from './components/IndustriesSection';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ConsultationModal from './components/ConsultationModal';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="bg-[#F5F5F7] dark:bg-[#0B0B0C] transition-colors duration-500 font-sans min-w-0">
      <Navbar onConsultationClick={() => setModalOpen(true)} />

      <main>
        <section><HeroSection onConsultationClick={() => setModalOpen(true)} /></section>
        <section><ProblemSection /></section>
        <section><SolutionSection /></section>
        <section><IndustriesSection /></section>
        <section><ProcessSection /></section>
        <section><CTASection onConsultationClick={() => setModalOpen(true)} /></section>
      </main>

      <Footer />
      <ConsultationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
